import { Component, h, Host, Prop } from '@stencil/core';

export type SpinnerVariant = 'small' | 'large';
/// Loading indicator
@Component({
  tag: 'uui-spinner',
  styleUrl: 'uui-spinner.css',
  shadow: true
})
export class UuiSpinner {
  /** option to render small or large spinner */
  @Prop({ reflect: true }) variant: SpinnerVariant = 'large';

  render() {
    if (this.variant === 'small') {
      return (
        <uui-icon
          color="var(--uui-theme-secondary-400)"
          type={'circle-notch'}
          spin={true}
          size="xl"
        />
      );
    }

    return (
      <Host>
        <div class="loading">
          <div class="wrapper">
            <div class="animation">
              <div class="dot"></div>
              <div class="dot2"></div>
              <div class="dot3"></div>
              <div class="dot4"></div>
            </div>
          </div>
        </div>
        <div class="slot-container">
          <slot />
        </div>
      </Host>
    );
  }
}
